
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Filtros() { return this.Controlador.Buscador.Filtros; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }

        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        onAbierto()
        {
            if ( this.Abierto )
            {
                this.SoloLeidos = this.Filtros.Valores.SoloLeidos == 1;
                this.SoloActivas = this.Filtros.Valores.SoloActivas == 1;
            } else
            {
                let bus = false;
                if ( this.SoloActivas != ( this.Filtros.Valores.SoloActivas == 1 ) || this.SoloLeidos != ( this.Filtros.Valores.SoloLeidos == 1 ) )
                    bus = true;


                this.Filtros.Valores.SoloLeidos = this.SoloLeidos ? 1 : 0;
                this.Filtros.Valores.SoloActivas = this.SoloActivas ? 1 : 0;

                if ( bus )
                    this.Buscador.Buscar( 1 );
            }
        }

        public SoloActivas: boolean = false;
        public SoloLeidos: boolean = false;

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
